import { secp256k1 } from "@noble/curves/secp256k1";
import { sha256 } from "@noble/hashes/sha256";
import { privateKeyToAccount } from "viem/accounts";
import { bytesToHex, hexToBytes, keccak256 } from "viem";
import { Keypair } from "@solana/web3.js";
import bs58 from "bs58";

export function evmAddressFromSecp256k1(privateKey: Uint8Array): string {
  const account = privateKeyToAccount(bytesToHex(privateKey));
  return account.address;
}

export function solanaAddressFromEd25519(privateKey: Uint8Array): string {
  const keypair = Keypair.fromSeed(privateKey);
  return keypair.publicKey.toBase58();
}

export function tronAddressFromSecp256k1(privateKey: Uint8Array): string {
  // Uncompressed public key minus the 0x04 prefix byte
  const pubKeyUncompressed = secp256k1.getPublicKey(privateKey, false).slice(1);
  const hash = keccak256(pubKeyUncompressed);
  // Last 20 bytes of the keccak256 hash
  const addressBytes = hexToBytes(hash).slice(12);
  // Tron prefix 0x41 + address bytes
  const tronBytes = new Uint8Array([0x41, ...addressBytes]);
  // Double SHA-256 checksum (first 4 bytes)
  const checksum = sha256(sha256(tronBytes)).slice(0, 4);
  return bs58.encode(new Uint8Array([...tronBytes, ...checksum]));
}

export function privateKeyToExportHex(privateKey: Uint8Array): string {
  return bytesToHex(privateKey);
}

export function ed25519PrivateKeyToExportBase58(
  privateKey: Uint8Array,
): string {
  // Phantom expects the full 64-byte keypair (32-byte seed + 32-byte public key)
  const keypair = Keypair.fromSeed(privateKey);
  return bs58.encode(keypair.secretKey);
}
